import(/* webpackMode: "eager" */ "/app/apps/store/app/error.tsx")